import { blockCategories } from '../../categories';

const COMPONENT_TYPE = 'ship-field';
const BLOCK_ID = 'ship-field';
const PLACEHOLDER_LABEL = 'Schiffsfeld';

const SHIP_FIELD_OPTIONS = [
    { value: 'images', name: 'Bilder' },
    { value: 'accommodation', name: 'Unterkunft' },
    { value: 'description', name: 'Beschreibung' },
    { value: 'cabinInformation', name: 'Kabineninformationen' },
    { value: 'equipment', name: 'Ausstattung' },
    { value: 'technicalData', name: 'Technische Daten' },
    { value: 'shipPlan', name: 'Deckplan' },
];

export default function shipField(editor) {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    domComponents.addType(COMPONENT_TYPE, {
        isComponent: (el) => {
            if (
                el?.classList?.contains('sio-ship-section') ||
                el?.classList?.contains('sio-ship-field') ||
                el?.getAttribute?.('data-siotype') === COMPONENT_TYPE
            ) {
                return { type: COMPONENT_TYPE };
            }
            return undefined;
        },
        model: {
            defaults: {
                tagName: 'div',
                name: PLACEHOLDER_LABEL,
                droppable: false,
                draggable: true,
                stylable: true,
                highlightable: true,
                editable: false,
                attributes: {
                    class: 'sio-jd-ship sio-ship-field',
                    'data-siotype': COMPONENT_TYPE,
                    'data-field-label': PLACEHOLDER_LABEL,
                },
                components: [],
                traits: [
                    {
                        type: 'select',
                        name: 'shipField',
                        label: 'Anzeigen',
                        options: SHIP_FIELD_OPTIONS,
                        value: 'images',
                        changeProp: true,
                    },
                ],
            },
            init() {
                this.on('change:shipField', this.updateFieldLabel);
                this.updateFieldLabel();
            },

            updateFieldLabel() {
                const selectedField = this.get('shipField');

                const selectedOption = SHIP_FIELD_OPTIONS.find(
                    ({ value }) => value === selectedField
                );

                const fieldLabel = selectedOption
                    ? `${PLACEHOLDER_LABEL}: ${selectedOption.name}`
                    : PLACEHOLDER_LABEL;

                this.addAttributes({
                    'data-field-label': fieldLabel,
                });
            },
        },

        view: {},
    });
    blockManager.add(BLOCK_ID, {
        label: PLACEHOLDER_LABEL,
        category: blockCategories.journeyDetail,
        media: `<svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M20 17h-1V8c0-1.1-.9-2-2-2h-3V4h-4v2H7c-1.1 0-2 .9-2 2v9H4v2h16v-2Zm-9-9h2v2h-2V8Zm0 4h2v2h-2v-2Zm-4-4h2v2H7V8Zm0 4h2v2H7v-2Zm8-4h2v2h-2V8Zm0 4h2v2h-2v-2Z"/>
        </svg>`,
        content: {
            type: COMPONENT_TYPE,
            attributes: {
                class: 'sio-jd-ship sio-ship-field',
                'data-siotype': COMPONENT_TYPE,
                'data-field-label': PLACEHOLDER_LABEL,
            },
        },
    });
}
